var $ = require('jquery');

(function ($, window, document, undefined) {

    /*
     * DOCUMENT READY
     */

    $(document).ready(function () {

        if($('form.validate-form.sortenfinder-form').length > 0) {
            $('form.validate-form.sortenfinder-form').submit(function() {
                $('form.validate-form.sortenfinder-form').addClass('loading', true);
            });

            $('form.validate-form.sortenfinder-form').parsley().on('field:validated', function() {
                var ok = $('.parsley-error').length === 0;

                if (!ok) {
                    $('form.validate-form.sortenfinder-form').removeClass('loading');
                }

            }).on('form:submit', function() {
                //return false; // Don't submit form for this demo
            });
        }
    });

})(jQuery, window, document);